<div class="">
  <div class="container card shadow pb-5">
    <app-page-header
      [header]="'Mi Cuenta'"
      [breadcrumbs]="[
        { label: 'Inicio', url: '../../' },
        { label: 'Mi Cuenta', url: '' }
      ]"
    ></app-page-header>
    <div class="row">
      <div class="col-md-6 flex">
        <div class="card flex-grow-1 mb-md-0 card-1">
          <div class="card-body">
            <h3 class="card-title">Iniciar sesión</h3>
            <form>
              <div class="mb-3">
                <label>Email</label>
                <input
                  type="email"
                  class="form-control"
                  placeholder="Ingrese email"
                />
              </div>
              <div class="mb-3">
                <label>Contraseña</label>
                <input
                  type="password"
                  class="form-control"
                  placeholder="Ingrese contraseña"
                />
                <small class="form-text text-muted">
                  <a href="">Olvidé mi contraseña</a>
                </small>
              </div>
              <div class="mb-3">
                <div class="form-check">
                  <span class="form-check-input input-check">
                    <span class="input-check__body">
                      <input
                        class="input-check__input"
                        type="checkbox"
                        id="login-remember"
                      />
                      <span class="input-check__box"></span>
                      <app-icon
                        class="input-check__icon"
                        name="check-9x7"
                        size="9x7"
                      ></app-icon>
                    </span>
                  </span>
                  <label class="form-check-label" for="login-remember"
                    >Recordarme</label
                  >
                </div>
              </div>
              <button
                name="ingresar"
                type="submit"
                class="btn btn-primary mt-2 mt-md-3 mt-lg-4"
              >
                Ingresar
              </button>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-6 flex mt-4 mt-md-0">
        <div class="card flex-grow-1 mb-0 card-1">
          <div class="card-body">
            <h3 class="card-title">Registrarse</h3>
            <form>
              <div class="mb-3">
                <label>Email</label>
                <input
                  type="email"
                  class="form-control"
                  placeholder="Ingrese email"
                />
              </div>
              <div class="mb-3">
                <label>contraseña</label>
                <input
                  type="password"
                  class="form-control"
                  placeholder="Password"
                />
              </div>
              <div class="mb-3">
                <label>Repita la contraseña</label>
                <input
                  type="password"
                  class="form-control"
                  placeholder="Password"
                />
              </div>
              <button
                name="Registrarse"
                type="submit"
                class="btn btn-primary mt-2 mt-md-3 mt-lg-4"
              >
                Registrarse
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
